'use client';
import { DynamicIcon } from 'phosphor-icons/react';
import { c } from '../../../utils/tailwind-merge';

type CheckboxIndicatorProps = {
  isSelected: boolean;
};

export const CheckboxIndicator = ({ isSelected }: CheckboxIndicatorProps) => {
  return (
    <div className="px-3">
      <span
        className={c(
          'flex h-4 w-4 flex-shrink-0 items-center justify-center rounded transition-colors',
          isSelected ? 'border-2 border-blue bg-blue' : 'border border-grey-500'
        )}
      >
        {isSelected && (
          <DynamicIcon
            iconName="Check"
            size={12}
            className="text-white"
            weight="bold"
            aria-hidden="true"
            focusable="false"
          />
        )}
      </span>
    </div>
  );
};
